(function() {
    const modalElement = document.querySelector(".modal");
    modalElement.querySelector(".modal__close").addEventListener("click", ()=>modalElement.classList.remove("modal--visible"));
    modalElement.addEventListener("click", ()=>modalElement.classList.remove("modal--visible"));
    modalElement.querySelector(".modal__dialog").addEventListener("click", (e)=>e.stopPropagation());
    function loadScript(url) {
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        head.appendChild(script);
    }
    function serialize(form) {
        const obj = new URLSearchParams();
        if (!form.checkValidity()) throw Error("Invalid");
        const inputs = form.querySelectorAll("input");
        inputs.forEach(({ name , value  })=>{
            obj.append(name, value);
        });
        return obj;
    }
    const anchors = document.querySelectorAll('a[href*="#"]');
    anchors.forEach((anchor)=>{
        anchor.addEventListener("click", function(e) {
            e.preventDefault();
            document.querySelector(anchor.getAttribute("href")).scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    });
    const forms = document.querySelectorAll("form");
    forms.forEach((form)=>{
        form.addEventListener("submit", function(e) {
            e.preventDefault();
            forms.forEach((form)=>{
                form.querySelector("button[type=submit]").disabled = true;
            });
            try {
                const serialized = serialize(form);
                loadScript("https://listta.activehosted.com/proc.php?" + serialized + "&jsonp=true");
            } catch (e) {
                window._show_error(undefined, "Something went wrong!");
            }
        });
    });
    window._show_thank_you = function(id, message) {
        modalElement.classList.add("modal--visible");
        const textElement = modalElement.querySelector(".modal__text");
        textElement.innerText = message;
    };
    window._show_error = function(id, message) {
        forms.forEach((form)=>{
            form.querySelector("button[type=submit]").disabled = false;
            const errors = form.querySelectorAll(".form__error");
            errors.forEach((error)=>{
                error.classList.remove("form__error--hidden");
                error.innerText = message;
            });
        });
    };
})();
(function SliderImageLoader() {
    const images = document.querySelectorAll(".slider__item img");
    const isWebpSupports = document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
    images.forEach(function(el, index) {
        const next = images.item(index + 1);
        el.addEventListener("load", function() {
            if (next?.previousElementSibling) {
                const img = new Image();
                if (isWebpSupports) img.src = next.previousElementSibling.getAttribute("srcset");
                else img.src = next.getAttribute("src");
            }
        });
    });
})();

//# sourceMappingURL=index.6c020477.js.map
